<template>
	<div class="slide-price">
		<div class="slide-price--row">
			<!-- <input v-model.number="value" type="range" :min="nFrom" :max="nTo" :step="nStep" /> -->
			<span class="slide-price--label"  @click="decrementHandler">-</span>
			<div ref="main" class="slide-price--main">
				<div ref="thumb" class="slide-price--thumb" :style="style"></div>
				<div class="slide-price--line"></div>
			</div>
			<span class="slide-price--label" @click="incrementHandler">+</span>
		</div>
		<div class="slide-price--row">
			<span class="slide-price--value">{{ pValue }}</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'slide-price',
	props: {
		from: String,
		to: String,
		step: String,
		locale: String,
		currency: String,
		initvalue: {
			type: String,
			default: '40'
		}
	},
	data() {
		return {
			value: -1,
			dragging: false,
			thumb: {
				x: 0
			}
		}
	},
	computed: {
		nFrom() {
			return Number.parseFloat(this.from)
		},
		nTo() {
			return Number.parseFloat(this.to)
		},
		nStep() {
			return Number.parseFloat(this.step)
		},
		style() {
			return {
				left: `calc(${this.thumb.x}% - (20px * (${this.thumb.x} / 100)))`
			}
		},
		pValue() {
			const country = this.getCountry()
			const locale = `${country.locale}-${country.country.toUpperCase()}`
			const currency = country.currency.toUpperCase()
			return `${this.value.toLocaleString(this.locale || locale || 'pt-PT', { style: "currency", currency: this.currency || currency || "EUR", minimumFractionDigits: 2 })}`
		}
	},
	methods: {
		mouseMoveHandler(e) {
			if (!this.dragging)
				return

			const client = {
				x: 0
			}

			if (e instanceof MouseEvent) {
				client.x = e.clientX
			} else {
				client.x = e.touches[0].clientX
			}

			const tag = this.$refs.main
			const pos = tag.getBoundingClientRect()
			const seekPos = ((client.x - pos.left) / pos.width)

			this.thumb.x = Math.min(100, Math.max(0, Number.parseFloat(100 * seekPos)))
			return this.pauseEvent(e)
		},
		mouseDownHandler(e) {
			this.dragging = true
			return this.pauseEvent(e)
		},
		mouseUpHandler() {
			this.dragging = false
		},
		pauseEvent(e) {
			e = e || window.event

			if(e.stopPropagation)
				e.stopPropagation()

			if(e.preventDefault)
				e.preventDefault()

			e.cancelBubble = true
			e.returnValue = false

			return false
		},
		calculateValue() {
			const interval = this.nTo - this.nFrom
			this.value = this.nFrom + Math.ceil((interval * this.thumb.x / 100) / 5) * this.step
		},
		calculatePosition() {
			const interval = this.nTo - this.nFrom
			const current = this.value - this.nFrom
			this.thumb.x = current * 100 / interval
		},
		setValue(value) {
			this.value = value
			this.calculatePosition()
		},
		decrementHandler() {
			this.setValue(Math.max(this.nFrom, this.value - this.nStep))
		},
		incrementHandler() {
			this.setValue(Math.min(this.nTo, this.value + this.nStep))
		},
		getCountry() {
			return document.head.querySelector("[name~=country][content]").content
				.split(',')
				.map(e => e.trim())
				.map(e => e.split('='))
				.reduce((result, element) => {
					result[element[0]] = element[1]
					return result
				}, {})
		},
		triggerUpdate(value) {
			const country = this.getCountry()
			const locale = `${country.locale}-${country.country.toUpperCase()}`
			const currency = country.currency.toUpperCase()

			this.$emit('slide-change', {
				value: value,
				formatted: `${value.toLocaleString(this.locale || locale || 'pt-PT', { style: "currency", currency: this.currency || currency || "EUR", minimumFractionDigits: 2 })}`
			})
		}
	},
	watch: {
		value(newV, oldV) {
			this.triggerUpdate(newV)
		},
		'thumb.x'(newV, oldV) {
			this.calculateValue()
		}
	},
	mounted() {
		// set default value and emit event
		this.setValue(Number.parseFloat(this.initvalue))

		setTimeout(() => {
			this.triggerUpdate(Number.parseFloat(this.initvalue))
		}, 700)

		// events
		this.$refs.thumb.addEventListener('mousedown', this.mouseDownHandler, { passive: false, capture: false })
		this.$refs.thumb.addEventListener('touchstart', this.mouseDownHandler, { passive: false, capture: false })
		document.body.addEventListener('mousemove', this.mouseMoveHandler, { passive: false, capture: false })
		document.body.addEventListener('touchmove', this.mouseMoveHandler, { passive: false, capture: false })
		document.body.addEventListener('mouseup', this.mouseUpHandler, { passive: false, capture: false })
		document.body.addEventListener('touchend', this.mouseUpHandler, { passive: false, capture: false })
	}
}
</script>

<style scoped>
.slide-price {
	display: flex;
	flex-direction: column;
}
.slide-price--row {
	display: flex;
}
.slide-price--label {
	flex: 0 0 20px;
	font-size: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: Montserrat,sans-serif;
	user-select: none;
	cursor: pointer;
}
.slide-price--main {
	flex: 1;
	position: relative;
	height: 20px;
}
.slide-price--thumb {
	position: absolute;
	top: 0;
	left: 0;
	width: 20px;
	height: 20px;
	background-color: #000;
	cursor: pointer;
}
.slide-price--line {
	position: absolute;
	top: 50%;
	width: 100%;
	height: 1px;
	background-color: #000;
	pointer-events: none;
}
.slide-price--value {
	margin: 10px 0 20px 0;
	font-size: 15px;
	font-weight: 700;
	letter-spacing: .15em;
	color: #7c7c7c;
	font-family: Montserrat,sans-serif;
}
</style>
